import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js

const EditPurchaseChannel = () => {
    const { id } = useParams(); // Get the purchase channel ID from the URL
    const navigate = useNavigate();

    // State for holding the purchase channel data
    const [formData, setFormData] = useState({
        pack_unit: '',
        pack_qty: '',
        unit: '',
        quantity: '',
        free_quantity: '',
        rate: '',
        amount: '',
        mrp: '',
        net_rate: '',
        remark: '',
        item_barcode: '',
        bd_batch_no: '',
        bd_mfg_date: '',
        bd_exp_date: '',
        bd_sale_rate: '',
        item_balance: '',
        barcode: '',
        line_level_barcode: '',
        hsn_code: '',
        brand: ''
    });

    // Fetch purchase channel details on component mount
    useEffect(() => {
        fetch(`${BASE_URL}purchasechannels/${id}`)
            .then(response => response.json())
            .then(data => {
    console.log(data); // Log data to inspect
    if (data) {
        setFormData({
            pack_unit: data.pack_unit || '',
            pack_qty: data.pack_qty || '',
            unit: data.unit || '',
            quantity: data.quantity || '',
            free_quantity: data.free_quantity || '',
            rate: data.rate || '',
            amount: data.amount || '',
            mrp: data.mrp || '',
            net_rate: data.net_rate || '',
            remark: data.remark || '',
            item_barcode: data.item_barcode || '',
            bd_batch_no: data.bd_batch_no || '',
            bd_mfg_date: data.bd_mfg_date || '',
            bd_exp_date: data.bd_exp_date || '',
            bd_sale_rate: data.bd_sale_rate || '',
            item_balance: data.item_balance || '',
            barcode: data.barcode || '',
            line_level_barcode: data.line_level_barcode || '',
            hsn_code: data.hsn_code || '',
            brand: data.brand || ''
        });
    }
})
.catch(error => console.error('Error fetching purchase channel details:', error));

    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        const updatedPurchaseChannel = {
            ...formData, // Spread form data to send all fields
        };

        fetch(`${BASE_URL}purchasechannels/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedPurchaseChannel),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    // Navigate to the purchase channel list or show success message
                    alert("Purchase return channel updated successfully!");
                    navigate('/PurchaseChannelsList'); // Assuming the route to list is `/PurchaseChannelsList`
                } else {
                    alert("Error updating purchase channel. Please try again.");
                }
            })
            .catch(error => console.error('Error updating purchase channel:', error));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Purchase Channel</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Purchase Channel Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="packUnit" className="form-label">Pack Unit</label>
                                        <input
                                            type="text"
                                            id="packUnit"
                                            name="pack_unit"
                                            className="form-control"
                                            value={formData.pack_unit}
                                            onChange={handleChange}
                                            placeholder="Enter pack unit"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="packQty" className="form-label">Pack Quantity</label>
                                        <input
                                            type="number"
                                            id="packQty"
                                            name="pack_qty"
                                            className="form-control"
                                            value={formData.pack_qty}
                                            onChange={handleChange}
                                            placeholder="Enter pack quantity"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="unit" className="form-label">Unit</label>
                                        <input
                                            type="text"
                                            id="unit"
                                            name="unit"
                                            className="form-control"
                                            value={formData.unit}
                                            onChange={handleChange}
                                            placeholder="Enter unit"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="quantity" className="form-label">Quantity</label>
                                        <input
                                            type="number"
                                            id="quantity"
                                            name="quantity"
                                            className="form-control"
                                            value={formData.quantity}
                                            onChange={handleChange}
                                            placeholder="Enter quantity"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="freeQuantity" className="form-label">Free Quantity</label>
                                        <input
                                            type="number"
                                            id="freeQuantity"
                                            name="free_quantity"
                                            className="form-control"
                                            value={formData.free_quantity}
                                            onChange={handleChange}
                                            placeholder="Enter free quantity"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="rate" className="form-label">Rate</label>
                                        <input
                                            type="number"
                                            id="rate"
                                            name="rate"
                                            className="form-control"
                                            value={formData.rate}
                                            onChange={handleChange}
                                            placeholder="Enter rate"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            name="amount"
                                            className="form-control"
                                            value={formData.amount}
                                            onChange={handleChange}
                                            placeholder="Enter amount"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="mrp" className="form-label">MRP</label>
                                        <input
                                            type="number"
                                            id="mrp"
                                            name="mrp"
                                            className="form-control"
                                            value={formData.mrp}
                                            onChange={handleChange}
                                            placeholder="Enter MRP"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="netRate" className="form-label">Net Rate</label>
                                        <input
                                            type="number"
                                            id="netRate"
                                            name="net_rate"
                                            className="form-control"
                                            value={formData.net_rate}
                                            onChange={handleChange}
                                            placeholder="Enter net rate"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="remark" className="form-label">Remark</label>
                                        <input
                                            type="text"
                                            id="remark"
                                            name="remark"
                                            className="form-control"
                                            value={formData.remark}
                                            onChange={handleChange}
                                            placeholder="Enter remark"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="itemBarcode" className="form-label">Item Barcode</label>
                                        <input
                                            type="text"
                                            id="itemBarcode"
                                            name="item_barcode"
                                            className="form-control"
                                            value={formData.item_barcode}
                                            onChange={handleChange}
                                            placeholder="Enter item barcode"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="bdBatchNo" className="form-label">Batch No</label>
                                        <input
                                            type="text"
                                            id="bdBatchNo"
                                            name="bd_batch_no"
                                            className="form-control"
                                            value={formData.bd_batch_no}
                                            onChange={handleChange}
                                            placeholder="Enter batch number"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="bdMfgDate" className="form-label">Manufacture Date</label>
                                        <input
                                            type="date"
                                            id="bdMfgDate"
                                            name="bd_mfg_date"
                                            className="form-control"
                                            value={formData.bd_mfg_date}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="bdExpDate" className="form-label">Expiry Date</label>
                                        <input
                                            type="date"
                                            id="bdExpDate"
                                            name="bd_exp_date"
                                            className="form-control"
                                            value={formData.bd_exp_date}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="bdSaleRate" className="form-label">Sale Rate</label>
                                        <input
                                            type="number"
                                            id="bdSaleRate"
                                            name="bd_sale_rate"
                                            className="form-control"
                                            value={formData.bd_sale_rate}
                                            onChange={handleChange}
                                            placeholder="Enter sale rate"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="itemBalance" className="form-label">Item Balance</label>
                                        <input
                                            type="number"
                                            id="itemBalance"
                                            name="item_balance"
                                            className="form-control"
                                            value={formData.item_balance}
                                            onChange={handleChange}
                                            placeholder="Enter item balance"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="barcode" className="form-label">Barcode</label>
                                        <input
                                            type="text"
                                            id="barcode"
                                            name="barcode"
                                            className="form-control"
                                            value={formData.barcode}
                                            onChange={handleChange}
                                            placeholder="Enter barcode"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="lineLevelBarcode" className="form-label">Line Level Barcode</label>
                                        <input
                                            type="text"
                                            id="lineLevelBarcode"
                                            name="line_level_barcode"
                                            className="form-control"
                                            value={formData.line_level_barcode}
                                            onChange={handleChange}
                                            placeholder="Enter line level barcode"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="hsnCode" className="form-label">HSN Code</label>
                                        <input
                                            type="text"
                                            id="hsnCode"
                                            name="hsn_code"
                                            className="form-control"
                                            value={formData.hsn_code}
                                            onChange={handleChange}
                                            placeholder="Enter HSN code"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="brand" className="form-label">Brand</label>
                                        <input
                                            type="text"
                                            id="brand"
                                            name="brand"
                                            className="form-control"
                                            value={formData.brand}
                                            onChange={handleChange}
                                            placeholder="Enter brand"
                                            required
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary">Update Purchase Channel</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditPurchaseChannel;
